export default "__VITE_ASSET__5d566657__"